import React, { useState } from "react";
import * as yup from "yup";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import { Principal } from "@dfinity/agent";
import { toast } from "react-toastify";
import CardContent from "@origyn-sa/common-ui/src/components/atoms/CardContent";
import { H2, H3 } from "@origyn-sa/common-ui/src/components/atoms/H/H.styled";
import Form from "@origyn-sa/common-ui/src/components/templates/Form";
import InputField from "@origyn-sa/common-ui/src/components/molecules/InputField";
import Button from "@origyn-sa/common-ui/src/components/atoms/Button";
import { client } from "../../agent";
import { LinearProgress } from "@material-ui/core";

export interface ICollectionModal {
  open: boolean;
  onClose: () => void;
  initData?: any;
  onUpdate?: () => void;
}

const schema = yup.object().shape({});

const CollectionModal = ({
  open,
  onClose,
  initData,
  onUpdate,
}: ICollectionModal) => {
  const [errors, setErrors]: [{ [key: string]: string }, any] = useState<any>(
    {}
  );
  const [loader, setLoader] = useState<boolean>(false);

  const handleFormChange = async (data: any) => {
    try {
      setLoader(true);
      const isUpdate = initData;
      await client.actor[isUpdate ? "updateCollection" : "addCollection"]({
        _principal: !initData && Principal.fromText(data.canisterId),
        enabled: true,
        ...(initData || {}),
        fee:
          data.fee && data.feeRecipient
            ? {
                fee: Math.round(Number(data.fee) * 10 ** 2),
                feeRecipient: Principal.fromText(data.feeRecipient),
              }
            : undefined,
      });
      toast.success(`Collection ${isUpdate ? "updated" : "created"}`);
      onClose();
      if (onUpdate) {
        onUpdate();
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoader(false);
    }
  };

  const handleValidation = (data: any) => {
    setErrors(data);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      {loader && <LinearProgress style={{ width: "100%", top: 0, left: 0 }} />}
      <CardContent textAlign='center' padding='40px 55px'>
        <Grid container justify='center' spacing={1}>
          <Grid item>
            <H3 spacing={[0, 3]}>Create a new collection</H3>
          </Grid>
        </Grid>
        <Form
          onSubmit={handleFormChange}
          schema={schema}
          onValidation={handleValidation}
        >
          <Grid container>
            <Grid item xs={12}>
              <InputField
                required
                disabled={!!initData}
                defaultValue={initData && initData._principal.toString()}
                error={errors.canister}
                label='NFT Canister Principal ID'
                name='canisterId'
                placeholder='Canister ID'
              />
            </Grid>
            <Grid item xs={12}>
              <InputField
                required
                defaultValue={initData && Number(initData.fee.fee) / 10 ** 2}
                error={errors.fee}
                label='Fee for each sale (%)'
                name='fee'
                placeholder='Fee, %'
              />
            </Grid>
            <Grid item xs={12}>
              <InputField
                required
                error={errors.canister}
                defaultValue={initData && initData.fee.feeRecipient.toString()}
                label='Recipient ID'
                name='feeRecipient'
                placeholder='Recipient Principal ID'
              />
            </Grid>
          </Grid>
          <Button disabled={loader} type='submit' spacing={2}>
            {initData ? "Update" : "Create"}
          </Button>
        </Form>
      </CardContent>
    </Dialog>
  );
};

export default CollectionModal;
